import NextLink from 'next/link';
import { colors } from 'components/styles/variables';
import css from 'styled-jsx/css';
import { AnchorHTMLAttributes } from 'react';
import { EngagementTypes } from 'lib/Tracking/NavBarClick';
import { useLog } from './useNavBarClickLog';

/* istanbul ignore next */
const styles = css`
  .link {
    background-color: white;
    color: ${colors.BLACK};
    font-size: 16px;
    font-weight: 300;
    position: relative;
    display: inline-block;
    border: none;
    padding: 20px 10px 20px 10px;
    cursor: pointer;
    text-decoration: none;
  }

  .link.active,
  .link:hover {
    color: ${colors.ALR1};
  }
`;

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  engagementType: EngagementTypes;
  isActive?: boolean;
}

function Link({
  children,
  engagementType,
  className,
  isActive,
  href,
  ...passThrough
}: LinkProps): JSX.Element {
  const log = useLog();

  return (
    <NextLink href={href as string} legacyBehavior prefetch={false}>
      <a
        target="_top"
        href={href}
        className={`${isActive ? 'active' : ''} ${className || ''} link`}
        {...passThrough}
        onClick={(): void => {
          log(engagementType);
        }}
      >
        {children}
        <style jsx>{styles}</style>
      </a>
    </NextLink>
  );
}

export { styles };
export default Link;
